import axios from "axios";
import { getToken } from "../../Utlis/UpdateUserState";

const getModules = async () => {
  try {
    const res = await axios.get(
      `${process.env.REACT_APP_BACKEND_URL}config/modules/`,
    );
    return res;
  } catch (e) {
    console.log(e);
    return e?.response || e;
  }
};

const getVendorTypes = async () => {
  try {
    const token = getToken();

    const res = await axios.get(
      `${process.env.REACT_APP_BACKEND_URL}lookups/vendor-types/`,
      {
        headers: token ? { Authorization: `Bearer ${token}` } : {},
      },
    );

    return res;
  } catch (e) {
    console.log(e);
    return e?.response || e;
  }
};

const getFuelTypes = async () => {
  try {
    const token = getToken();

    const res = await axios.get(
      `${process.env.REACT_APP_BACKEND_URL}lookups/fuel-types/`,
      {
        headers: token ? { Authorization: `Bearer ${token}` } : {},
      },
    );

    return res;
  } catch (e) {
    console.log(e);
    return e?.response || e;
  }
};

const getFuelBrands = async () => {
  try {
    const token = getToken();

    const res = await axios.get(
      `${process.env.REACT_APP_BACKEND_URL}lookups/fuel-brands/`,
      {
        headers: token ? { Authorization: `Bearer ${token}` } : {},
      },
    );

    return res;
  } catch (e) {
    console.log(e);
    return e?.response || e;
  }
};

const getDocumentCategories = async (scope) => {
  try {
    const token = getToken();

    const res = await axios.get(
      `${process.env.REACT_APP_BACKEND_URL}lookups/document-categories/?scope=${encodeURIComponent(scope)}`,
      {
        headers: token ? { Authorization: `Bearer ${token}` } : {},
      },
    );

    return res;
  } catch (e) {
    console.log(e);
    return e?.response || e;
  }
};

const validateNavixyApiKey = async (apiKey) => {
  try {
    const res = await axios.post(
      `${process.env.REACT_APP_BACKEND_URL}lookups/navixy-api-key/validate/`,
      { api_key: apiKey },
    );
    const status = res?.data?.data?.status;
    return ["valid", "invalid", "ambiguous"].includes(status)
      ? status
      : "ambiguous";
  } catch (e) {
    console.log(e);
    return "ambiguous";
  }
};

export {
  getModules,
  validateNavixyApiKey,
  getFuelTypes,
  getVendorTypes,
  getFuelBrands,
  getDocumentCategories,
};
